import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Observable } from 'rxjs'

import { AuthenticationService } from '@/services/authentication.service'

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  // Public endpoints that should NOT send Authorization header
  // (Warden/devise-jwt validates JWT before controller, causing 401 even with skip_before_action)
  private readonly publicEndpoints = [
    '/merchants/find_by_hostname',
    '/api/v1/auth/refresh'
  ]

  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue
    const isLoggedIn = currentUser && currentUser.token
    const isPublicEndpoint = this.publicEndpoints.some(endpoint => request.url.includes(endpoint))

    if (isLoggedIn && !isPublicEndpoint) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      })
    }

    return next.handle(request)
  }
}